import script from "./QuizzIllustrationAnswer.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizzIllustrationAnswer.vue?vue&type=script&setup=true&lang=ts"

import "./QuizzIllustrationAnswer.vue?vue&type=style&index=0&id=10a7339c&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a7339c"]])

export default __exports__